import { clsx } from 'clsx'

import { useRouter } from '@tribeplatform/react-sdk'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Text } from '@tribeplatform/react-ui-kit/Text'
import type { TextVariant } from '@tribeplatform/react-ui-kit/Text'

interface Props {
  highlighted?: boolean
  titleVariant?: TextVariant
  linkTo?: string
  title: string
  isSingleEvent?: boolean
  isEventPage?: boolean
  lineClamp?: 1 | 2 | 3
  textClassName?: string
  hasIcon?: boolean
  iconClassName?: string
}
export const EventFieldTitle = ({
  highlighted,
  titleVariant,
  linkTo,
  title,
  isSingleEvent,
  isEventPage,
  lineClamp = 3,
  textClassName,
  hasIcon,
  iconClassName,
}: Props) => {
  const { Link } = useRouter()
  const titleHeadingSize = isEventPage ? 'h1' : 'h2'

  const lineClampClassMap = {
    1: 'line-clamp-1',
    2: 'line-clamp-2',
    3: 'line-clamp-3',
  }

  const lineClampClass = lineClampClassMap[lineClamp]

  if ((isSingleEvent && isEventPage) || !linkTo) {
    return (
      <div
        className={clsx(
          'min-w-0 break-words',
          lineClampClass,
          highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        )}
      >
        <Text
          as={titleHeadingSize}
          variant={titleVariant}
          className={textClassName}
        >
          {title}
          {hasIcon && (
            <SvgIcon
              name="arrow-right"
              className={clsx('inline ml-1', iconClassName)}
            />
          )}
        </Text>
      </div>
    )
  }

  return (
    <Link
      href={linkTo}
      variant="inherit"
      className="break-words min-w-0 inline-block"
      onClick={e => e.stopPropagation()}
    >
      <Text
        as={titleHeadingSize}
        variant={titleVariant}
        className={clsx(
          textClassName,
          lineClampClass,
          highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        )}
      >
        {title}
        {hasIcon && (
          <SvgIcon
            name="arrow-right"
            className={clsx('inline ml-1', iconClassName)}
          />
        )}
      </Text>
    </Link>
  )
}
